//removeIf(production)
import ClaroluzEvents from "../../../../../infra/critical/claroluz-events";
import ClaroluzData from "../../../../../domain/entities/claroluz-data";
//removeIf(production)
import ClaroluzDataDatasource from "../../../../../external/datasources/claroluz-data-datasource";
import ClaroluzDataDatasourceDev from "../../../../../external/datasources/claroluz-data-datasource-dev";
import ClaroluzDataRepository from "../../../../../infra/repositories/claroluz-data-repository";
import ExternalStatus from "../../../../../enums/external-status";
import ClaroluzEventError from "../../../../../infra/services/claroluz-event-error";
import ClaroluzComparator from "../../comparator/comparator/comparator";
import GetTimeDiference from "../../../../../domain/usecases/get-time-diference";
import IClaroluzDataDatasource from "../../../../../infra/datasources/i-claroluz-data-datasource";
import ClaroluzEventDispatch from "../../../../../infra/services/claroluz-event-dispatch";
//endRemoveIf(production)

class ClaroluzSubmit {
    private timeout: number = 8;

    constructor() {
        this.submitEvent();
    }

    private async submitEvent() {
        document.addEventListener('claroluz_submit', async (event: any) => {
            const properties = appProperties();
            const type = event.detail.type;
            const data = event.detail.data;
            let response: ClaroluzData | false = false;
            GetTimeDiference.startTimer();

            let datasource: IClaroluzDataDatasource = new ClaroluzDataDatasource(type);
            if (properties.datasource.indexOf('local') !== -1) {
                datasource = new ClaroluzDataDatasourceDev(properties.datasource, type);
            }
            const repository = new ClaroluzDataRepository(datasource);

            switch (type) {
                case 'pdf':
                    this.openModal();
                    response = await repository.getOffersByPdf(data);
                    break;
                case 'qr-code':
                    this.openModal();
                    response = await repository.getOffersByUrl(data);
                    break;
                case 'cups':
                    this.openModal();
                    response = await repository.getOffersByCups(data);
                    break;
            
                default:
                    throw new Error("ClaroluzSubmit: Invalid type");      
            }

            new ClaroluzEvents(properties, 'uploader', 'submit', type, response);

            if (response.status != ExternalStatus.CLAROLUZ_SUCCESS && response.status != ExternalStatus.CLAROLUZ_NO_OFFERS) {
                new ClaroluzEventError(type, response.status);
            } else {
                new ClaroluzComparator(response);
            }

            GetTimeDiference.endTimer();
            if (properties.debug) {
                let time = new Date().toLocaleTimeString();
                let timeDiference  = GetTimeDiference.getTimeDiference();
                let color = timeDiference > this.timeout ? 'color: red' : 'color: green';
                console.log(`[${time}] ` + 'Request duration: %c' + timeDiference + 's', `font-weight: bold; ${color}`);
            }

            this.closeModal();
        });
    }

    private openModal() {
        new ClaroluzEventDispatch('claroluz_loading_start', { timeout: this.timeout });
    }

    private closeModal() {
        new ClaroluzEventDispatch('claroluz_loading_hide');
    }
}

//removeIf(production)
function appProperties(): import("../../../../../infra/critical/claroluz-events-properties").default {
    throw new Error("Function not implemented.");
}

export default ClaroluzSubmit;
//endRemoveIf(production)